export default () => {
  return new Promise(function (resolve) {
    resolve({
      brand: {
        name: "Motanamy",
        desc: "End-to-end software solutions built to scale with your ambition.",
        subDesc: "Advanced Engineering. Intelligent Apps. Limitless Growth.",
        footerText: "All rights reserved 2025.",
        url: "motanamy.com",
        img: "/images/logo.png",
      },
      plan: {
        monthly: "Monthly",
        annual: "Annual",
        bestSeller: "best seller",
        eternal: "Empire",
        year: "Year",
        free: "Free",
        _24hourSupport: "24 hours support",
        personal: "Personal",
        smallBusinesses: "Small companies",
        mediumCompanies: "Medium companies",
        yourPrank: "Your plan for your joke",
        number: "number",
        user: "user",
        role: "Role",
      },
      header: {
        feature: "Why Us",
        faq_title: "FAQ",
        services: "Services",
        solutions: "Solutions",
        process: "Our Process",
        portfolio: "Portfolio",
        techStack: "Tech Stack",
        testimonials: "Reviews",
        pricing: "Pricing",
        contact: "Contact",
        more: "More",
        about: "About",
        team: "Team",
        serial: "Get License",
        blog: "Blog",
        developers: "Partners",
        steps: "Steps",
        screenshots: "Screenshots",
        home: "Home",
        search: "Search",
        download: "Downloads",
        usage: "Terms of Use",
        policy: "Privacy",
        store: "Portfolio",
        company: "Company",
        links: "Quick Links",
        login: "Sign In",
        applications: "Solutions",
      },
      policy: {
        privacy: "privacy,Privacy%20Policy%20%28EN%29.md",
        usage: "privacy,Usage%20Policy%20%28EN%29.md",
        privacyDesc: "Read our privacy policy to learn more about how we handle your data and protect your privacy.",
        usageDesc: "Read our usage policy to learn more about how you can use our products and services.",
      },
      store: {
        title: "Software Solutions",
        month: "month",
        list_related: "Related Projects",
        subtitle:
          "Custom engineering and digital solutions designed to power your business growth.",
      },
      faq: {
        title: "Questions & Answers.",
        desc: "Every question in your head — the answer is probably right here.",
        topic: "Browse topics",
        link: "faq,en.faq.json",
      },
      landing: {
        back: "Go to the home page",
        "404_subtitle":
          "You can either stay and relax here, or return to the beginning.",
        btn_detail: "See details",
        util_soon: "almost",
        util_soon_desc: "It will come in the next version",
        explorer: "Explore Solution",
        getStarted: "Start Your Project",
        watchVideo: "Watch Our Story",
        projects: "Projects Delivered",
        clients: "Happy Clients",
        years: "Years Experience",
        application: "Solution",
        whoWeAreDesc: "We build custom software solutions that scale with your business. Modern web platforms, native mobile apps, and robust cloud architectures crafted by an expert engineering team.",
        ecosystemKicker: "Our Capabilities",
        ecosystemTitle: "Full-Cycle Software Engineering.",
        ecosystemDesc: "From conceptualization and UI/UX design to cloud deployment and ongoing optimization — we guide you at every stage.",
        ecosystemMarketplace: "We apply industry-standard architecture, rock-solid security, and modern frameworks to guarantee peak performance and reliability.",
        ecosystemCta: "Explore Our Services",
        servicesKicker: "Our Expertise",
        servicesTitle: "Custom Software Solutions Tailored to You.",
        servicesDesc: "We develop enterprise web applications, cross-platform mobile apps, desktop systems, and intelligent AI integrations.",
        servicesCustomNote: "Need a bespoke system tailored exactly to your workflow? We build and scale your dedicated infrastructure.",
        servicesCta: "Get in Touch to Start",
        service_plugin: "Custom Systems & Integrations",
        service_plugin_desc: "Tailored software modules, API microservices, and system integrations.",
        service_website: "Web Platforms & SaaS",
        service_website_desc: "Fast, responsive, secure web platforms and cloud-native applications.",
        service_desktop: "Desktop & Enterprise Apps",
        service_desktop_desc: "High-performance software for Windows, macOS, and Linux.",
        service_mobile: "Mobile App Development",
        service_mobile_desc: "Production-grade iOS and Android apps built to scale to millions.",
        feature1: "Precision Engineering.",
        feature2: "Enterprise-Grade Security.",
        feature3: "Bespoke & Scalable.",
        blogDesc: "Sharp insights and tech ideas for those building the digital future.",
        developerKicker: "Technology Partnership",
        developerTitle: "Build Your Next System With Motanamy.",
        developerSubtitle: "A dedicated engineering team providing architectural consulting, custom software development, and reliable cloud management.",
        developerDocsBtn: "Request a Consultation",
        partnerNote: "A strategic partnership that builds your digital future.",
        becomePartnerBtn: "Start a Project With Us",
        pluginsKicker: "Our Domains",
        pluginsTitle: "End-to-End Digital Capabilities",
        pluginsSubtitle: "Web apps, mobile apps, cloud infrastructure, and intelligent automation.",
        pluginsViewAll: "View All Solutions",
        processKicker: "Our Process",
        processTitle: "How We Turn Ideas Into Resilient Software",
        processSubtitle: "A streamlined agile methodology ensuring clarity, rapid delivery, and supreme quality.",
        step1Title: "1. Discovery & Strategy",
        step1Desc: "In-depth requirement analysis, architectural planning, and a clear project roadmap.",
        step2Title: "2. UI/UX Architecture",
        step2Desc: "Interactive wireframes and polished UI designs focused on effortless user experience.",
        step3Title: "3. Agile Development & QA",
        step3Desc: "Clean, modular code with automated testing, CI/CD pipelines, and strict security checks.",
        step4Title: "4. Deployment & Growth",
        step4Desc: "Cloud launch, performance monitoring, and dedicated 24/7 post-launch evolution.",
        portfolioBadge: "Our Work",
        portfolioTitle: "Projects We're Proud Of",
        portfolioSubtitle: "A curated showcase of software products and digital solutions engineered for our clients.",
        serialDes:
          "In order to allow you to use our programs, you must contact us first to give you the product of the product.",
        quality: "High Quality",
        support: "24/7 Support",
        innovation: "Continuous Innovation",
        updates: "Maintenance & Updates",
      },
      contact: {
        ready: "You have an idea. Let's make it real.",
        btn_contact: "Get in Touch",
        contact_title: "We're here.",
        dec: "Your idea deserves more than an email. Tell us about it — we'll build the rest together.",
        form_name: "Your name *",
        selectService: "Service you need",
        form_email: "Your email *",
        form_phone: "Your phone number",
        form_company: "Your company",
        form_message: "What do you want to build?",
        form_terms: "I agree to the",
        form_privacy: "Privacy & Usage Policy *",
        form_send: "Send.",
        send_message_title: "Your message is on its way.",
        send_message_subtitle: "We'll get back to you shortly.",
        success_message: "Received. Thank you.",
        email_label: "Email",
        phone_label: "Phone",
        whatsapp_label: "WhatsApp",
        telegram_label: "Telegram",
        working_hours_label: "Working Hours",
        working_days: "Saturday - Thursday",
        working_time: "9:00 AM - 6:00 PM",
        contactDesc: "Private plugin. Custom app. A website that reflects who you are. We're here for all of it.",
        whatsapp_tooltip: "Message us on WhatsApp",
        whatsapp_message: "Hello! I'd like to learn more about your services.",
        form_subject: "Subject *",
        form_department: "Department",
        dept_general: "General",
        dept_sales: "Sales",
        dept_support: "Support",
        name_required: "Name is required",
        email_required: "Email is required",
        email_invalid: "Please enter a valid email address",
        subject_required: "Subject is required",
        message_required: "Message is required",
        terms_required: "You must agree to the privacy and usage policy",
        rate_limit_error: "You have reached the maximum number of submissions. Please wait before trying again.",
        general_error: "Failed to send message. Please try again.",
        phone_append_label: "Phone Number"
      },
      store: {
        title: "The Marketplace.",
        month: "Month",
        list_related: "You might also like",
        subtitle:
          "Pick your feature. Install it. Go. Can't find what you need? We'll build it just for you.",
      },
      about: {
        team: "The team is the difference.",
        teamDes:
          "People who build, not just talk. We design, develop, and support everything you need — plugins, products, and digital experiences — with precision and without the noise.",
        about: "Motanamy",
        aboutDes:
          "Complex inside. Seamless outside. Three products, one integrated ecosystem, and a team that turns your ideas into reality.",
        // Hero
        heroLine1: "We shape the future,",
        heroLine2: "one line of code at a time.",
        heroDes: "At Motanamy, we don't just develop software; we build ecosystems that evolve with your ambition and speak the language of your era.",
        scrollDown: "Discover more",
        // Philosophy
        philosophyLabel: "Our Philosophy",
        philosophyTitle: "Technology as a philosophy, not just a tool.",
        philosophyBody: "We believe great software is invisible in its simplicity, leaving you the space to excel in your business. Our complexity inside is your seamless experience outside.",
        // Impact numbers
        impactEyebrow: "Our Impact in Numbers",
        impactSuccess: "Success Stories",
        impactPartners: "Partners in Growth",
        impactYears: "Years of Passion",
        // CTA
        ctaEyebrow: "Next Step",
        ctaTitle: "Ready to grow?",
        ctaSub: "Let's start a real conversation about your project.",
        ctaBtn: "Start the Conversation",
        video: "Watch our story",
        ourCapabilities: "What we do best.",
        capabilitiesDesc: "We build what gets used — not just what looks good on paper.",
        whyChooseUs: "Why Motanamy?",
        whyChooseUsDesc: "Because complexity disappears when we take over.",
        qualityDesc: "Quality that isn't up for debate.",
        supportDesc: "Real support. Any time.",
        innovationDesc: "Solutions that move with you.",
        updatesDesc: "Continuous growth. No pause.",
        ourValues: "What we stand for.",
        ourValuesDesc: "Principles that shape every decision.",
        trustValue: "Trust first.",
        trustValueDesc: "We deliver what we promise. Always.",
        innovationValue: "Innovation without limits.",
        innovationValueDesc: "We chase the best — even when it's unprecedented.",
        teamworkValue: "Your success is a shared file.",
        teamworkValueDesc: "One team. One goal. One outcome.",
        excellenceValue: "Excellence is our minimum.",
        excellenceValueDesc: "Good isn't enough — we aim for exceptional.",
        // Mission & Vision
        ourMission: "Our Mission.",
        missionDesc: "Turn complexity into a delightful experience. Every day.",
        missionPoint1: "Software built to be used.",
        missionPoint2: "Partnerships that last.",
        missionPoint3: "Real digital transformation, not cosmetic.",
        ourVision: "Our Vision.",
        visionDesc: "To be the obvious choice. For the company that wants to grow with depth.",
        visionPoint1: "Leadership without pretense.",
        visionPoint2: "Regional and global reach.",
        visionPoint3: "Innovation that anticipates tomorrow.",
        // Services
        whatWeOffer: "What we make.",
        ourServices: "Our Services.",
        servicesDesc: "Plugin. App. Website. Dashboard. Whatever you need — we build it with precision.",
        serviceMobile: "Mobile Applications",
        serviceMobileDesc: "Your idea in your hands. iOS and Android apps designed around your goals.",
        serviceDesktop: "Desktop Applications",
        serviceDesktopDesc: "Native performance. Daily ease. For every work environment.",
        serviceDashboard: "Dashboards",
        serviceDashboardDesc: "Data at your service. Faster decisions. Total control.",
        serviceWebsite: "Websites",
        serviceWebsiteDesc: "A digital presence worthy of your ambition. Fast. Responsive. Elegant.",
        featureIOS: "iOS",
        featureAndroid: "Android",
        featureCrossPlatform: "Cross-platform",
        featureWindows: "Windows",
        featureMac: "Mac",
        featureLinux: "Linux",
        featureAdmin: "Admin",
        featureAnalytics: "Analytics",
        featureReports: "Reports",
        featureResponsive: "Responsive",
        featureSEO: "SEO",
        featureModern: "Modern",
        // Timeline
        ourJourney: "Our Journey",
        milestones: "Our Milestones",
        milestonesDesc: "Discover the important milestones in our journey towards excellence and success",
        milestone2019: "The Beginning.",
        milestone2019Desc: "First step. Firm. No hesitation.",
        achievement2019_1: "First successful project.",
        achievement2019_2: "A team that believes in what it builds.",
        milestone2020: "Growth.",
        milestone2020Desc: "More clients. Deeper services.",
        achievement2020_1: "50+ projects delivered.",
        achievement2020_2: "Strategic partnerships.",
        milestone2022: "Recognition.",
        milestone2022Desc: "Our clients' trust is our highest award.",
        achievement2022_1: "Technical excellence acknowledged.",
        achievement2022_2: "100+ satisfied clients.",
        milestone2024: "Innovation.",
        milestone2024Desc: "New solutions. Newer technology. Deeper impact.",
        achievement2024_1: "Ambitious new products.",
        achievement2024_2: "Technologies yet to be explored.",
        milestone2025: "What's next.",
        milestone2025Desc: "The future isn't a goal — it's a project in progress.",
        achievement2025_1: "Regional expansion.",
        achievement2025_2: "Global partnerships.",
      },
      apps: {
        pricingOrder: "Request a Quote.",
        watchPlans: "The plans are clear. Pick what fits — or reach out if you need a hand.",
        yourOrder: "Order your copy.",
        yourKey: "Get your key.",
        featureSubtitle: "What makes this app different — in plain words.",
        downloadSubtitle: "Choose your platform. Install. Start.",
        downloadNow: "Download Now",
        recommended: "Recommended",
        fileSize: "File Size",
        downloads: "Downloads",
        rating: "Rating",
        users: "Users",
        learnMore: "Learn More",
        secure: "Secure",
        fast: "Fast",
        screenshots: "Screenshots",
        screenshotsSubtitle: "Take a closer look at the interface, workflow, and features before installation.",
        totalScreenshots: "Screenshots",
        hdQuality: "HD",
        quality: "Quality",
        clickToZoom: "360°",
        viewDetail: "View Detail",
        appBadge: "App",
        learnMoreBtn: "Learn More",
        getStartedPlugin: "Get started from here",
        noApps: "No applications found",
      },
      seo: {
        home: {
          title: "Motanamy — Software Development & Mobile App Agency",
          desc: "Custom software development, mobile apps, and business automation — built to scale. One ecosystem. No limits.",
        },
        about: {
          title: "About Motanamy — Custom Software Built to Scale",
          desc: "Meet the team behind Motanamy. We build mobile apps, web systems, and automation solutions for businesses ready to grow.",
        },
        services: {
          title: "Software Development Services — Motanamy",
          desc: "Mobile apps, desktop software, dashboards, and websites. Expert software development services tailored for your business.",
        },
        mobile: {
          title: "Mobile App Development — iOS & Android | Motanamy",
          desc: "iOS and Android app development that turns ideas into apps people actually use. Fast builds. Elegant UX. Real results.",
        },
        desktop: {
          title: "Desktop Software Development — Windows, Mac & Linux | Motanamy",
          desc: "Native desktop apps for Windows, Mac, and Linux. Reliable performance. Built around your workflow.",
        },
        website: {
          title: "Website Development Services — Fast, SEO-Ready | Motanamy",
          desc: "Professional website development — responsive, SEO-optimized, and built to reflect your brand. No templates. Just precision.",
        },
        plugin: {
          title: "Software Plugins & Business Automation Tools — Motanamy",
          desc: "Ready-to-install plugins and custom automation tools. One click. No waiting. Or we'll build it for you.",
        },
        contact: {
          title: "Contact Motanamy — Start Your Software Project",
          desc: "Have an app idea or a software project? Contact Motanamy. We reply fast and build faster.",
        },
        faq: {
          title: "FAQ — Software Development Questions | Motanamy",
          desc: "Answers to common questions about software development, mobile apps, and business automation at Motanamy.",
        },
        blog: {
          title: "Blog — Software Development Insights | Motanamy",
          desc: "Sharp ideas. Concise reads. On software development, mobile apps, and business automation — for those who build.",
        },
        store: {
          title: "Plugin Marketplace — Business Automation Tools | Motanamy",
          desc: "Browse Motanamy's marketplace. Ready-to-install plugins and business automation tools. Pick. Install. Go.",
        },
      },
      lang: {
        en: "English",
        ar: "العربيّة",
        header_language: "language",
        header_theme: "Theme mode",
        header_dark: "dark",
        header_light: "light",
        header_search: "Search",
      },
      services: [
        {
          title: "Mobile App Development (iOS & Android)",
          body: "High-performance, intuitive mobile apps built with cutting-edge Flutter, Ionic, and native mobile technologies.",
          img: "/images/mobile.svg",
          url: "/services/mobile",
        },
        {
          title: "Cloud Web Platforms & SaaS Solutions",
          body: "Scalable, secure, and modern web applications engineered for speed, SEO supremacy, and seamless user interaction.",
          img: "/images/website.svg",
          url: "/services/website",
        },
        {
          title: "Enterprise Desktop & Management Systems",
          body: "Robust, stable software architectures for desktop environments, ERPs, inventory, and operational management.",
          img: "/images/desktop.svg",
          url: "/services/desktop",
        },
        {
          title: "Custom Software & System Integrations",
          body: "Bespoke software modules, microservices, REST/GraphQL APIs, and AI-powered workflow automations.",
          img: "/images/plugin.svg",
          url: "/services/plugin",
        },
      ],
      features: [
        {
          title: "Scalable Cloud Architecture.",
          body: "We engineer resilient cloud systems capable of handling millions of requests with zero downtime.",
          icon: "mdi-server-network",
        },
        {
          title: "World-Class UI/UX Design.",
          body: "Sleek, human-centered interfaces that make complex enterprise workflows intuitive and engaging.",
          icon: "mdi-monitor-dashboard",
        },
        {
          title: "100% Tailored Engineering.",
          body: "No rigid off-the-shelf templates. Every line of code is tailored to your exact business objectives.",
          icon: "mdi-laptop",
        },
        {
          title: "Agile Speed & Rapid Delivery.",
          body: "Iterative sprint delivery with continuous QA, instant feedback loops, and on-time milestone delivery.",
          icon: "mdi-rocket-launch-outline",
        },
        {
          title: "Seamless API & ERP Integrations.",
          body: "Connect payment gateways, CRMs, logistics, messaging, and legacy systems smoothly.",
          icon: "mdi-api",
        },
        {
          title: "Uncompromising Data Security.",
          body: "Enterprise-grade encryption, vulnerability defense, and stringent compliance standards.",
          icon: "mdi-shield-lock-outline",
        },
        {
          title: "AI & Workflow Automation.",
          body: "Empower your operations with modern AI models and automated business pipelines.",
          icon: "mdi-robot-outline",
        },
        {
          title: "Continuous 24/7 Support & DevOps.",
          body: "Proactive uptime monitoring, security patches, and performance optimizations around the clock.",
          icon: "mdi-wrench-clock",
        },
        {
          title: "Strategic Tech Consulting.",
          body: "Experienced engineering leaders guiding technology selection, cloud cost reduction, and scalability.",
          icon: "mdi-face-agent",
        },
        {
          title: "Cross-Platform Cohesion.",
          body: "Consistent user experiences across mobile, web, desktop, and tablet platforms.",
          icon: "mdi-devices",
        },
        {
          title: "Actionable Analytics & Insights.",
          body: "Real-time analytics dashboards that turn raw data into strategic business decisions.",
          icon: "mdi-chart-areaspline",
        },
        {
          title: "Long-Term Strategic Partnership.",
          body: "We stand with you beyond launch to help your products evolve and capture new market opportunities.",
          icon: "mdi-handshake-outline",
        },
      ],
      plugin: {
        featureTitle: "The right plugin changes everything.",
        features: [
          {
            title: "Fits you exactly.",
            body: "Marketplace-ready or fully private — built for how you work, not the other way around.",
            icon: "mdi-puzzle-outline",
          },
          {
            title: "Integrates. Never disrupts.",
            body: "Slips seamlessly into your ecosystem — the only difference is in the results.",
            icon: "mdi-puzzle-plus-outline",
          },
          {
            title: "Start small. Scale freely.",
            body: "Modular architecture that grows with your business — no rebuild needed.",
            icon: "mdi-cube-outline",
          },
          {
            title: "Speaks your systems.",
            body: "APIs, third-party services, internal data — all connected and ready.",
            icon: "mdi-api",
          },
          {
            title: "Docs that need no translation.",
            body: "Clear guidance so your team builds with confidence, not guesswork.",
            icon: "mdi-book-open-variant",
          },
          {
            title: "We stay after delivery.",
            body: "Updates, fixes, enhancements — here as long as you need us.",
            icon: "mdi-headset",
          },
        ],
        processTitle: "How we build your plugin.",
        process: [
          {
            color: "cyan",
            icon: "mdi-lightbulb-on-outline",
            title: "Consultation",
            dec: "We understand what you actually need — before writing a single line of code.",
            duration: "1-2 Weeks",
          },
          {
            color: "pink",
            icon: "mdi-palette-outline",
            title: "Design & Planning",
            dec: "We map the full picture — structure, interface, flow, and integration points.",
            duration: "2-3 Weeks",
          },
          {
            color: "indigo",
            icon: "mdi-code-braces",
            title: "Development",
            dec: "Clean code. Real performance. Flexibility that lasts.",
            duration: "4-8 Weeks",
          },
          {
            color: "green",
            icon: "mdi-shield-check-outline",
            title: "Testing",
            dec: "We test everything until we trust everything.",
            duration: "1-2 Weeks",
          },
          {
            color: "amber",
            icon: "mdi-rocket-launch-outline",
            title: "Launch & Maintenance",
            dec: "We ship. We stay. For updates, support, and what comes next.",
            duration: "Ongoing",
          },
        ],
      },
      mobile: {
        featureTitle: "Your app deserves more.",
        features: [
          {
            title: "Technology that serves you.",
            body: "No buzzwords — just real performance and easy long-term maintenance.",
            icon: "mdi-cellphone-link",
          },
          {
            title: "An experience you feel.",
            body: "UI aligned with how real users think — not how developers think.",
            icon: "mdi-palette-swatch-outline",
          },
          {
            title: "Your data, protected.",
            body: "Clear permissions, secure practices, unbreakable trust.",
            icon: "mdi-shield-lock-outline",
          },
          {
            title: "Fast. Stays fast.",
            body: "Performance at install is the same performance a year later.",
            icon: "mdi-speedometer",
          },
          {
            title: "Part of your ecosystem.",
            body: "Connects with APIs, cloud, dashboards — works as one seamless unit.",
            icon: "mdi-cloud-sync-outline",
          },
          {
            title: "With you after launch.",
            body: "Updates, maintenance, and real support at every new phase.",
            icon: "mdi-account-group-outline",
          },
        ],
        processTitle: "How we build your app.",
        process: [
          {
            color: "cyan",
            icon: "mdi-lightbulb-on-outline",
            title: "Ideation & Consultation",
            dec: "We clarify the goal, the user, and the value — before any design begins.",
            duration: "1-2 Weeks",
          },
          {
            color: "pink",
            icon: "mdi-palette-outline",
            title: "Design & Prototyping",
            dec: "Clear screens, real user journey, consistent visual identity.",
            duration: "2-3 Weeks",
          },
          {
            color: "indigo",
            icon: "mdi-code-braces",
            title: "Development",
            dec: "Solid code, strong integration, architecture built for growth.",
            duration: "4-8 Weeks",
          },
          {
            color: "green",
            icon: "mdi-shield-check-outline",
            title: "Testing",
            dec: "Across devices, scenarios, and real-world use cases.",
            duration: "1-2 Weeks",
          },
          {
            color: "amber",
            icon: "mdi-rocket-launch-outline",
            title: "Launch & Maintenance",
            dec: "We ship and stay — because launch is a beginning, not an end.",
            duration: "Ongoing",
          },
        ],
      },
      desktop: {
        featureTitle: "Desktop. Redefined.",
        features: [
          {
            title: "Works in your environment.",
            body: "Windows, Mac, Linux — same quality everywhere, no exceptions.",
            icon: "mdi-laptop",
          },
          {
            title: "Performance you feel.",
            body: "Instant response, smooth daily tasks, efficiency that never tires.",
            icon: "mdi-speedometer",
          },
          {
            title: "For teams of all sizes.",
            body: "Small internal tool or large enterprise system — built with equal seriousness.",
            icon: "mdi-office-building",
          },
          {
            title: "UI learned in a minute.",
            body: "Clarity in design means your team works, not learns.",
            icon: "mdi-monitor-dashboard",
          },
          {
            title: "Connected to everything.",
            body: "Databases, APIs, legacy systems — integrated seamlessly into your stack.",
            icon: "mdi-connection",
          },
          {
            title: "Secure. Reliable. Always.",
            body: "Access control, protected data, stability without surprises.",
            icon: "mdi-security",
          },
        ],
        processTitle: "How we build your desktop app.",
        process: [
          {
            color: "cyan",
            icon: "mdi-lightbulb-on-outline",
            title: "Requirements",
            dec: "We understand the operational need, users, and connected systems — before anything else.",
            duration: "1-2 Weeks",
          },
          {
            color: "pink",
            icon: "mdi-palette-outline",
            title: "Design & Prototyping",
            dec: "Clear screens, logical structure, a task flow that actually works.",
            duration: "2-3 Weeks",
          },
          {
            color: "indigo",
            icon: "mdi-code-braces",
            title: "Development",
            dec: "Practical features, stable performance, smooth integration in your environment.",
            duration: "4-8 Weeks",
          },
          {
            color: "green",
            icon: "mdi-shield-check-outline",
            title: "Testing",
            dec: "We verify every case until the system is ready for real-world use.",
            duration: "1-2 Weeks",
          },
          {
            color: "amber",
            icon: "mdi-rocket-launch-outline",
            title: "Launch & Maintenance",
            dec: "We deploy, support adoption, and keep evolving as your needs change.",
            duration: "Ongoing",
          },
        ],
      },
      web: {
        featureTitle: "Your website. Your window to the world.",
        features: [
          {
            title: "Tech that doesn't age.",
            body: "We choose what endures — fast now, easy to maintain tomorrow.",
            icon: "mdi-code-tags",
          },
          {
            title: "Works everywhere.",
            body: "Mobile, tablet, desktop — one consistent experience across every screen.",
            icon: "mdi-responsive",
          },
          {
            title: "Seen. Found.",
            body: "Proper SEO architecture from day one — not as an afterthought.",
            icon: "mdi-google",
          },
          {
            title: "Behaves like an app.",
            body: "PWA gives you app power with web flexibility — no compromise.",
            icon: "mdi-application-outline",
          },
          {
            title: "Fast and secure.",
            body: "Stable infrastructure, instant loading, uncompromising security.",
            icon: "mdi-shield-check",
          },
          {
            title: "Grows with you.",
            body: "Scalable code that expands with your content and business — no rebuild.",
            icon: "mdi-chart-line",
          },
        ],
        processTitle: "How we build your website.",
        process: [
          {
            color: "cyan",
            icon: "mdi-lightbulb-on-outline",
            title: "Discovery & Planning",
            dec: "We define the goal, structure, and user journey — before a single line of code.",
            duration: "1-2 Weeks",
          },
          {
            color: "pink",
            icon: "mdi-palette-outline",
            title: "Design & Prototyping",
            dec: "Designed around real content and your business goals — not empty templates.",
            duration: "2-3 Weeks",
          },
          {
            color: "indigo",
            icon: "mdi-code-braces",
            title: "Development",
            dec: "Clean code that balances speed, maintainability, and real business value.",
            duration: "4-8 Weeks",
          },
          {
            color: "green",
            icon: "mdi-shield-check-outline",
            title: "Testing",
            dec: "Across browsers, devices, and real scenarios — until the launch is flawless.",
            duration: "1-2 Weeks",
          },
          {
            color: "amber",
            icon: "mdi-rocket-launch-outline",
            title: "Launch & Maintenance",
            dec: "We launch. We improve. We stay — because a great website never stops growing.",
            duration: "Ongoing",
          },
        ],
      },
      portfolio: {
        aboutApp: "About the App",
        backToProjects: "Back to projects",
        keyFeatures: "What makes it different.",
        technologiesUsed: "Technologies Used",
        technologies: "Technologies",
        metrics: "Performance & Numbers",
        viewDetails: "View Details",
        notFound: "Project not found.",
        visitWebsite: "Visit Website",
        showcaseTitle: "We built them. They delivered.",
        showcaseSubtitle: "Mobile apps that transformed real businesses.",
        showcaseWebsitesTitle: "Websites that made a difference.",
        showcaseWebsitesSubtitle: "Web projects that reflect real identities.",
        showcaseDesktopTitle: "Desktop. Redefined.",
        showcaseDesktopSubtitle: "Powerful software solutions for real teams.",
        showcasePluginsTitle: "Plugins that changed workflows.",
        showcasePluginsSubtitle: "Custom integrations. Measurable results.",
      },
      blog: {
        minRead: "min read",
        shareArticle: "Share this article",
        copyLink: "Copy Link",
        linkCopied: "Link copied to clipboard!",
        copyFailed: "Failed to copy link",
        backToBlog: "Back to Blog",
        relatedPosts: "Related Posts",
        author: "Author",
        publishedOn: "Published on",
        lastUpdated: "Last updated",
        readMore: "Read More",
        categories: "Categories",
        tags: "Tags",
        tableOfContents: "Table of Contents",
        // New translations for enhanced blog page
        searchPlaceholder: "Search articles...",
        search: "Search",
        results: "Articles",
        searchFor: "Searching for",
        clear: "Clear",
        sort: "Sort By",
        newest: "Newest First",
        oldest: "Oldest First",
        title: "Title",
        noResults: "No articles found",
        tryDifferent: "Try adjusting your search or filter",
        clearFilters: "Clear Filters",
      }
    });
  });
};
